export default "<p>\r\n  float-sub-menu works!\r\n</p>\r\n"